export interface DecodeBoardLayout {
  renderable: boolean;
  boardRadius: number;
  centerRadius: number;
  centerX: number;
  centerY: number;
  height: number;
  ringWidth: number;
  width: number;
}

/** A detached or collapsing host cannot fit the central stone plus its surrounding rings. */
export function decodeBoardLayout(
  width: number,
  height: number,
  ringCount: number,
): DecodeBoardLayout {
  const boardRadius = Math.min(width * 0.465, height * 0.455);
  const centerRadius = Math.max(28, boardRadius * 0.18);
  const ringWidth = (boardRadius - centerRadius) / Math.max(1, ringCount);
  return {
    renderable:
      Number.isFinite(width) &&
      Number.isFinite(height) &&
      width > 0 &&
      height > 0 &&
      Number.isSafeInteger(ringCount) &&
      ringCount > 0 &&
      ringWidth > 0,
    boardRadius,
    centerRadius,
    centerX: width / 2,
    centerY: height / 2,
    height,
    ringWidth,
    width,
  };
}
